import React, { useState, useCallback } from 'react';
import ExperimentNav from '../../components/ExperimentNav';
import { experiments } from '../../App';
import './GenGrid.css';

const GRID_SIZE = 6;
const TOTAL = GRID_SIZE * GRID_SIZE;

interface Cell {
  bg: string;
  radius: string;
}

function generateCells(): Cell[] {
  return Array.from({ length: TOTAL }, () => {
    const h = Math.floor(Math.random() * 360);
    const s = 50 + Math.floor(Math.random() * 40);  // 50–90%
    const l = 35 + Math.floor(Math.random() * 40);   // 35–75%
    const bg = `hsl(${h}, ${s}%, ${l}%)`;

    // random border-radius: each corner independent
    const r = () => Math.floor(Math.random() * 50);
    const radius = `${r()}% ${r()}% ${r()}% ${r()}%`;

    return { bg, radius };
  });
}

const GenGrid: React.FC = () => {
  const [cells, setCells] = useState<Cell[]>(generateCells);
  const [transitioning, setTransitioning] = useState(false);
  const exp = experiments.find(e => e.id === 'gen-grid');

  const regenerate = useCallback(() => {
    setTransitioning(true);
    // brief fade-out then swap
    setTimeout(() => {
      setCells(generateCells());
      setTransitioning(false);
    }, 300);
  }, []);

  return (
    <div className="gg-wrapper">
      <div className="gg-scanlines" />
      <ExperimentNav prompt={exp?.prompt} title={exp?.title} />

      <div className="gg-content">
        <div className="gg-header">
          <span className="gg-label">GENERATIVE GRID</span>
          <span className="gg-sub">6 × 6 · {TOTAL} cells · refresh to randomize</span>
        </div>

        <div className={`gg-grid ${transitioning ? 'fade' : ''}`}>
          {cells.map((cell, i) => (
            <div
              key={i}
              className="gg-cell"
              style={{
                backgroundColor: cell.bg,
                borderRadius: cell.radius,
                animationDelay: `${i * 20}ms`,
              }}
            />
          ))}
        </div>

        <button className="gg-regen" onClick={regenerate}>
          ↻ regenerate
        </button>

        <div className="gg-meta">
          <span>hsl range: 0–360 / 50–90% / 35–75%</span>
          <span>border-radius: 0–50% per corner</span>
        </div>
      </div>
    </div>
  );
};

export default GenGrid;
